import React from "react";
import Icon from "../../../components/AppIcon";

const SocialProof = () => {
  const socialLinks = [
    {
      name: "GitHub",
      icon: "Github",
      url: "https://github.com/Yashya14",
      stats: "35+ repositories",
      color: "hover:text-foreground",
    },
    {
      name: "LinkedIn",
      icon: "Linkedin",
      url: "https://linkedin.com/in/yash-gajanan-pal",
      stats: "2K+ connections",
      color: "hover:text-trust-builder",
    },
    // {
    //   name: 'Twitter',
    //   icon: 'Twitter',
    //   url: 'https://twitter.com/johndoe',
    //   stats: '1.5K followers',
    //   color: 'hover:text-conversion-accent'
    // },
    // {
    //   name: 'Email',
    //   icon: 'Mail',
    //   url: 'mailto:yash@example.com',
    //   stats: 'Available 24/7',
    //   color: 'hover:text-cta'
    // }
  ];

  // const testimonials = [
  //   {
  //     text: "Exceptional developer with great attention to detail",
  //     author: "Sarah Chen",
  //     role: "Product Manager",
  //     company: "TechCorp"
  //   },
  //   {
  //     text: "Delivered our project ahead of schedule with perfect quality",
  //     author: "Mike Rodriguez",
  //     role: "CTO",
  //     company: "StartupXYZ"
  //   }
  // ];

  return (
    <div className="mt-16 space-y-12">
      {/* Social Links */}
      <div className="flex flex-wrap items-center justify-center gap-6 mb-10">
        {socialLinks?.map((social, index) => (
          <a
            key={index}
            href={social?.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`group flex items-center space-x-3 px-4 py-2 rounded-lg bg-card/30 border border-border/50 hover:bg-card/50 transition-smooth ${social?.color}`}
          >
            <Icon name={social?.icon} size={18} />
            <div className="text-left">
              <div className="text-sm font-medium">{social?.name}</div>
              <div className="text-xs text-muted-foreground">
                {social?.stats}
              </div>
            </div>
          </a>
        ))}
      </div>
      {/* Quick Testimonials */}
      {/* <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
        {testimonials?.map((testimonial, index) => (
          <div
            key={index}
            className="relative bg-card/30 backdrop-blur-sm border border-border/50 rounded-lg p-6 hover:bg-card/50 transition-smooth"
          >
            
            <div className="absolute top-4 right-4 text-conversion-accent/20">
              <Icon name="Quote" size={24} />
            </div>
            
            <div className="space-y-4">
              <p className="text-sm text-muted-foreground italic">
                "{testimonial?.text}"
              </p>
              
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-gradient-to-br from-conversion-accent to-trust-builder rounded-full flex items-center justify-center">
                  <span className="text-xs font-bold text-white">
                    {testimonial?.author?.split(' ')?.map(n => n?.[0])?.join('')}
                  </span>
                </div>
                <div>
                  <div className="text-sm font-medium">{testimonial?.author}</div>
                  <div className="text-xs text-muted-foreground">
                    {testimonial?.role} at {testimonial?.company}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div> */}
    </div>
  );
};

export default SocialProof;
